<template>
  <default>
    <div class="cust-pa-wrap">
      <pa-plan-select-page channel="customer" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import PaPlanSelectPage from '@/components/pa/PaPlanSelectPage';

export default {
  name: 'CustomerPaPlanSelect',
  components: { Default, PaPlanSelectPage },
  metaInfo: { title: 'Students PA — Select Cover' },
};
</script>

<style src="@/assets/css/customer-pa.css"></style>
